<template>
    <ProgressSpinner v-if="!type"/>
    <Container class="pt-6" v-if="type">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>{{ type.name ?? $route.params.type }}</PageHeading>
        </div>

	    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
        <TabLayout :tabs="tabs" sticky/>
	    </div>

        <router-view
		        @on-save="$emit('on-save')"
		        @on-delete="$emit('on-delete')"
		        :type="type"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useDeviceTypesStore } from "@/stores/deviceTypes.js";
import Container from "@/Components/Container.vue";


export default {
    name: "DeviceTypeView",
    components: {Container, TabLayout, PageHeading},
    data() {
        return {
            type: undefined,
        }
    },
    emits: [
        'on-save',
		    'on-delete',
    ],
    watch: {
        '$route.params.type': {
            async handler(newValue, oldValue) {
                if(newValue){
                    this.type = undefined;
                    if(this.$route.params.type === 'NEW'){
                        this.type = {};
                    } else {
                        this.type = await this.deviceTypesStore.showDeviceType( this.$route.params.type);
                    }
                } else {
                    this.type = undefined;
                }
            },
            immediate: true,
        }
    },
    computed: {
        ...mapStores(useDeviceTypesStore),
        tabs() {
            return [
                {
                    label: this.$t('common.properties'),
                    current: this.$route.name === 'admin.devices.types.type',
                    to: {name: 'admin.devices.types.type', params: this.$route.params}
                },
            ]
        }
    },
}
</script>
